import * as d3 from 'd3'

export default {
  methods: {

    draw_Values(selection) {
      let tube = this.tube
      let sch = this.schedule

      let tubeChart = selection
      .append('g')
      .attr('transform', `translate(.5, .5)`)

      // Progress
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness / 2},${tube.height + tube.textY + sch.actSize*0.36})`)
      .attr('font-size', sch.actSize).attr('font-weight', 400).attr('fill', this.gmx_deltaValue(this.rawData.DELTA_CUM))
      .attr('text-anchor', 'middle')
      .text(`${this.rawData.ACT_CUM}%`)

      // This Week
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness /2}, ${tube.scale(100) + sch.wkSize*0.36})`)
      .attr('font-size', sch.wkSize).attr('fill', this.gmx_deltaValue(this.rawData.DELTA_WK))
      .attr('text-anchor', 'middle')
      .text(`${this.rawData.ACT_WK}%`)

      this.gmx_Line(tubeChart, tube.tickness, tube.tickness + 20, tube.scale(100), tube.scale(100), '#bcbcbc', .5, 1)

      tubeChart
      .append('circle')
      .attr('cx', tube.tickness + 20).attr('cy', tube.scale(100))
      .attr('r', 2.5).attr('fill', '#bcbcbc')

      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness + 26},${tube.scale(100) + sch.tSize*0.36})`)
      .attr('font-size', sch.tSize).attr('fill', sch.tColor)
      .text(`This Week`)

      // Culmulative
      this.gmx_Line(tubeChart, tube.tickness, tube.tickness+10, tube.scale(this.rawData.ACT_CUM), tube.scale(this.rawData.ACT_CUM), '#bcbcbc', .5, 1)
      this.gmx_Line(tubeChart, tube.tickness+10, tube.tickness+20, tube.scale(30), tube.scale(30), '#bcbcbc', .5, 1)
      this.gmx_Line(tubeChart, tube.tickness+10, tube.tickness+10, tube.scale(30), tube.scale(this.rawData.ACT_CUM), '#bcbcbc', .5, 1)

      tubeChart
      .append('circle')
      .attr('cx', tube.tickness + 20).attr('cy', tube.scale(30))
      .attr('r', 2.5).attr('fill', '#bcbcbc')
      
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness + 26},${tube.scale(30) + sch.tSize*0.36})`)
      .attr('font-size', sch.tSize).attr('fill', sch.tColor)
      .text(`Culmulative`)

      this.draw_schedule(selection, 'WK', tube.tickness + 30, tube.scale(100))
      this.draw_schedule(selection, 'CUM', tube.tickness + 30, tube.scale(30))
    },
    


    draw_schedule(selection, sch_, x_, y_) {

      let sch = this.schedule
      let plan = this.rawData[`PLAN_${sch_}`]
      let delta = this.rawData[`DELTA_${sch_}`]

      let schedule = selection
      .append('g')
      .attr('transform', `translate(${x_}, ${y_})`)

      let tY = sch.lineheight
      schedule
      .append('text')
      .attr('transform', `translate(0, ${tY + sch.vSize*0.36})`)
      .attr('font-size', sch.vSize).attr('fill', sch.vColor)
      .text(plan+ '%')

      tY = tY + sch.lineheight
      schedule
      .append('text')
      .attr('id', `${sch_}_${this.localId}`)
      .attr('transform', `translate(0, ${tY + sch.vSize*0.36})`)
      .attr('font-size', sch.vSize).attr('fill', this.gmx_deltaValue(delta))
      .text(delta + '%')

      schedule // Icon
      .append('path')
      .attr('transform', `translate(${this.getNode(`#${sch_}_${this.localId}`,'width')+3}, ${tY - 4}) scale(.6)`)
      .attr('d', this.gmx_deltaValue(delta, 'icon'))
      .attr('fill', this.gmx_deltaValue(delta))
      .attr('stroke-width', .5)
    },

  }
}